export const ASM_DISCOVERY_JOB_TYPES = {
  SCAN: 'scan',
  DISCOVERY: 'discovery',
  VALIDATION: 'validation',
  TECHNOLOGY_DISCOVERY: 'technology_discovery',
  EXPLOITABILITY_SCAN: 'exploitability_scan'
};

export const ASM_SCORE_JOB_TYPES = {
  POSTURE: 'security_posture_score'
};

export const ASM_BULK_JOB_TYPES = {
  UPDATE: 'bulk_update',
  ADD_TO_TI: 'monitor_in_ti',
  UPDATE_ATTRIBUTE_IDS: 'bulk_update_attribute_ids'
};

export const ASM_JOB_TYPES = {
  ...ASM_DISCOVERY_JOB_TYPES,
  ...ASM_SCORE_JOB_TYPES,
  ...ASM_BULK_JOB_TYPES
};

export const ASM_JOB_WARNINGS = {
  REACHED_SUBDOMAIN_DISCOVERY_LIMIT: 'reached_subdomain_discovery_limit',
  REACHED_ASSET_LIMIT: 'reached_asset_limit',
  MISSING_AZURE_SUBSCRIPTION: 'azure_missing_subscription',
  MISSING_AWS_ACCOUNT: 'aws_missing_account',
  AZURE_LACK_OF_PERMISSIONS: 'azure_lack_of_permissions',
  AZURE_TOKEN_EXPIRED: 'azure_token_expired',
  INVALID_AWS_ACCOUNT_TOKEN: 'aws_invalid_account_token',
  AZURE_ACCOUNT_DISABLED: 'azure_account_disabled',
  AZURE_SUBSCRIPTION_NOT_EXISTS: 'azure_subscription_not_exists',
  REACHED_SYSTEM_DISCOVERED_ASSETS_LIMIT: 'reached_system_discovered_assets_limit',
  REACHED_CUSTOMER_DISCOVERED_ASSETS_LIMIT: 'reached_customer_discovered_assets_limit',
  ASM_CREDITS_LIMIT_EXCEEDED: 'asm_credits_limit_exceeded',
  ASM_LICENSE_LIMIT_EXCEEDED: 'asm_license_limit_exceeded',
  VALIDATION_JOB_ASSET_EXHAUSTION: 'validation_job_asset_exhaustion',
  INTERNAL_SERVICE_ERROR_1: 'internal_service_error_1',
  INTERNAL_SERVICE_ERROR_2: 'internal_service_error_2',
  INTERNAL_SERVICE_ERROR_201: 'internal_service_error_201',
  INTERNAL_SERVICE_ERROR_202: 'internal_service_error_202',
  INTERNAL_SERVICE_ERROR_203: 'internal_service_error_203',
  INTERNAL_SERVICE_ERROR_204: 'internal_service_error_204',
  INTERNAL_SERVICE_ERROR_205: 'internal_service_error_205',
  INTERNAL_SERVICE_ERROR_206: 'internal_service_error_206',
  INTERNAL_SERVICE_ERROR_207: 'internal_service_error_207',
  INTERNAL_SERVICE_ERROR_208: 'internal_service_error_208',
  AGENTIC_SCAN_FAILED: 'agentic_scan_failed'
};

export const ASM_JOB_FAILURES = {
  JOB_EXCEEDS_TTL_LIMIT: 'job_exceeds_ttl_limit',
  MAX_RETRIES_OPEN_PORTS: 'max_retries_open_ports_1',
  DNS_QUOTA_EXCEEDED: 'dns_quota_exceeded_1',
  CAASM_INTEGRATION_ERROR: 'caasm_integration_error'
};
